import React, { useState } from 'react';
import { Box, IconButton, Typography, Button, Menu, MenuItem } from '@mui/material';
import { ViewColumn, ViewModule, ViewComfy, ArrowDropDown } from '@mui/icons-material';

const ProductSortBar = ({ view, setView, sortBy, setSortBy, productCount }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSortChange = (value) => {
    setSortBy(value);
    handleClose();
  };

  const sortOptions = [
    { value: 'featured', label: 'Featured' },
    { value: 'best-selling', label: 'Best Selling' },
    { value: 'alphabetically-asc', label: 'Alphabetically, A-Z' },
    { value: 'alphabetically-desc', label: 'Alphabetically, Z-A' },
    { value: 'price-low-high', label: 'Price, Low to High' },
    { value: 'price-high-low', label: 'Price, High to Low' },
    // { value: 'date-old-new', label: 'Date, Old to New' },
    // { value: 'date-new-old', label: 'Date, New to Old' },
  ];

  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'space-between',
      mb: 2,
      borderTop: '1px solid',
      borderBottom: '1px solid',
      borderColor: 'divider',
      py: 1
    }}>
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center',
      }}>
        <IconButton
          onClick={() => setView('compact')}
          color={view === 'compact' ? 'primary' : 'default'}
          sx={{ display: { xs: 'none', sm: 'inline-flex' } }}
        >
          <ViewColumn />
        </IconButton>
        <IconButton
          onClick={() => setView('grid')}
          color={view === 'grid' ? 'primary' : 'default'}
        >
          <ViewModule />
        </IconButton>
        <IconButton 
          onClick={() => setView('large')} 
          color={view === 'large' ? 'primary' : 'default'}
        >
          <ViewComfy />
        </IconButton>
      </Box>
      <Typography variant="body2">
        {productCount} products found
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <Typography variant="body2" sx={{ mr: 1 }}>Sort by:</Typography>
        </Box>
        <Button
          id="sort-button"
          aria-controls={open ? 'sort-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          endIcon={<ArrowDropDown />}
          sx={{ 
            color: 'text.primary',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: 'transparent',
            },
          }}
        >
          {sortOptions.find(option => option.value === sortBy)?.label}
        </Button>
        <Menu
          id="sort-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'sort-button',
          }}
        >
          {sortOptions.map((option) => (
            <MenuItem 
              key={option.value} 
              onClick={() => handleSortChange(option.value)}
              selected={sortBy === option.value}
            >
              {option.label}
            </MenuItem>
          ))}
        </Menu>
      </Box>
    </Box>
  );
};

export default ProductSortBar;